import { Action, createReducer } from 'typesafe-actions';
import { UIState } from '../../types/ReduxMisc';
import {
  resetCardInstallments,
  clearSaveCardCheckbox,
  setCardInstallments,
  setSaveCardCheckbox,
} from '../actions/uiStateActions';

const initialState: UIState = {
  isSaveCardChecked: undefined,
  cardInstallments: 1,
};

export const uiStateReducer = createReducer<UIState, Action>(initialState)
  .handleAction(setSaveCardCheckbox, (uiState, action) => ({
    ...uiState,
    isSaveCardChecked: action.payload,
  }))
  .handleAction(clearSaveCardCheckbox, (uiState) => ({
    ...uiState,
    isSaveCardChecked: initialState.isSaveCardChecked,
  }))
  .handleAction(setCardInstallments, (uiState, action) => ({
    ...uiState,
    cardInstallments: action.payload,
  }))
  .handleAction(resetCardInstallments, (uiState) => ({
    ...uiState,
    cardInstallments: initialState.cardInstallments,
  }));
